import WebFont from 'webfontloader'
import nfp from '../../nativizeFoundationPromise.js'
import isLaunched from '../../isLaunched.js'

/**
 * Initiate a new login modal view that prompts the user to log in,
 * create an account, or have their password reset.
 * @constructor
 * @param {Object.<string,*>=} options
 * @extends {Foundation.Component.Ajax}
 */
Foundation.Login.Dialog = function (options) {
    // Default options.
    this.options = Foundation.extend({
        "callback": function () {},
        "member": new Foundation.Member(),
        "show": "LogIn",
        "feelingShy": false
    }, options || {});

    var sessionManager = Foundation.Session.Manager.sharedInstance();

    /**
     * @private
     * @type {Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd}
     */
    this._thirdPartyAuthShepherd = null;

    this.callbacks = [];
    this.callbacks.push(this.options["callback"]);
    sessionManager.observe("login", this.options["callback"]);

    // When someone requests a new dialog and one is already open...
    if (Foundation.Login.Dialog.activeDialog) {
        Foundation.Login.Dialog.activeDialog.then((function () {
            Foundation.Login.Dialog.activeDialog.callbacks.push(this.options["callback"]);
            Foundation.Login.Dialog.activeDialog.options = this.options;
            Foundation.Login.Dialog.activeDialog.showSubView(this.options["show"]);
        }).bind(this));
        return;
    }
    Foundation.Login.Dialog.activeDialog = this;

    /** @type {Foundation.View.ModalDialog} */
    this.dialog = new Foundation.View.ModalDialog();

    // Call the superclass and do the ajax request to get the LoginDialog HTML.
    var url = "/gyrobase/Login:LoginDialog";
    if (Foundation.MOBILE) url += "Mobile";
    Foundation.Component.Ajax.call(this, url, {
        "show": this.options["show"],
        "feelingShy": this.options["feelingShy"] ? 1 : 0,
        "callerUrl": window.location.toString()
    });

    // Load the webfonts the dialog uses
    const fontsLoaded = new Promise(resolve => WebFont.load({
        google: { families: ['Catamaran:400,700'] },
        active: () => resolve(),
        inactive: () => resolve(),
    }))

    // Once we've got a view from the server and we have loaded rest of login
    // dialog code, then we can finish initialization.
    Promise.all([
        isLaunched('login'),
        Foundation.load('foundation-login-dialog'),
        nfp(() => this),
        Foundation.Form.ReCaptcha.load(),
        fontsLoaded,
    ]).then(([loginLaunchToggle]) => {
        this.loginLaunchToggle = loginLaunchToggle
        this.dialog.then(() => this.init())
        this.dialog.setView(this.fullView)
    }).catch((err) => {
      //window.alert("Sorry, an error occurred and the login form could not be displayed. Please try again!")
      // eslint-disable-next-line no-console
      console.log(err)
    })

    // Destroy ourselves when the dialog is closed.
    this.dialog.closed().then(this.destroy.bind(this));
};
Foundation.inherit(Foundation.Login.Dialog, Foundation.Component.Ajax);

/**
 * Set the function for handling when the user opts for a "feeling shy" login.
 * @param {function(Object.<string,string>)} delegate
 */
Foundation.Login.Dialog.prototype.setFeelingShyLogInDelegate = function (delegate) {
    this.feelingShyDelegate = delegate;
};

/**
 * @private
 * @type {Foundation.Login.Dialog}
 */
Foundation.Login.Dialog.activeDialog = null;

Foundation.Login.Dialog.prototype.close = function () {
    this.dialog.close();
};

/**
 * @return {!Foundation.Promise}
 */
Foundation.Login.Dialog.prototype.closed = function () {
    return this.dialog.closed();
};

/**
 * Destructor. Cleans up after modal dialog closes.
 * @override
 */
Foundation.Login.Dialog.prototype.destroy = function () {
    var sessionManager = Foundation.Session.Manager.sharedInstance();
    sessionManager.unbind("login", this);
    if (this.visibleMicroComponent()) this.visibleMicroComponent().fire("hidden");
    Foundation.Login.Dialog.activeDialog = null;

    for (var i = 0; i < this.callbacks.length; i++) {
        sessionManager.unobserve("login", this.callbacks[i]);
    }

    if (this._thirdPartyAuthShepherd) {
        this._thirdPartyAuthShepherd.destroy()
    }

    // Destroy our view.
    if (this.dialog) this.dialog.destroy();

    // Call superclass destructor.
    Foundation.Component.Ajax.prototype.destroy.call(this);
};

// ---------------------------------------------------------------------

window["Foundation"]["Login"]["Dialog"] = Foundation.Login.Dialog;
